<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: String, default: "" },
  id: { type: String, default: undefined },
  name: { type: String, default: undefined },
  // [{ value: 'val', label: 'Label' }]
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: "Selecione uma opção" },
  disabled: { type: Boolean, default: false },
  status: { type: String, default: null },
});

defineEmits(["update:modelValue", "blur", "focus"]);

const classes = computed(() => [
  "ca-select",
  props.status === "error" && "ca-select--error",
  props.status === "success" && "ca-select--success",
]);
</script>

<template>
  <select
    :class="classes"
    :id="id"
    :name="name"
    :value="modelValue"
    :disabled="disabled"
    @change="$emit('update:modelValue', $event.target.value)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <option v-if="placeholder" value="" disabled :selected="!modelValue">
      {{ placeholder }}
    </option>
    <option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :selected="option.value === modelValue"
    >
      {{ option.label }}
    </option>
  </select>
</template>
